import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

export interface FormValues {
  firstName: string;
  lastName: string;
  dob: string;
  pronoun: string;
  email: string;
  phoneNumber: string;
  timeZone: string;
  coachType: string;
  description: string;
}

export const initialValues: FormValues = {
  firstName: '',
  lastName: '',
  dob: '',
  pronoun: '',
  email: '',
  phoneNumber: '',
  timeZone: '',
  coachType: '',
  description: '',
};

const minDate = new Date();
minDate.setFullYear(minDate.getFullYear() - 100);

const isPhoneNumberValid = (value: string) => isValidPhoneNumber(value);

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('addNewCoach.validations.firstName'),
  lastName: Yup.string().required('addNewCoach.validations.lastName'),
  dob: Yup.date()
    .required('addNewCoach.validations.dobRequired')
    .min(minDate, 'addNewCoach.validations.dobMin')
    .max(new Date(), 'addNewCoach.validations.dobMax')
    .typeError('addNewCoach.validations.dobTypeError'),
  pronoun: Yup.string().required('addNewCoach.validations.pronoun'),
  email: Yup.string()
    .email('addNewCoach.validations.emailInvalid')
    .required('addNewCoach.validations.emailRequired'),
  phoneNumber: Yup.string()
    .required('addNewCoach.validations.phoneNumberRequired')
    .test('phoneNumber', 'addNewCoach.validations.phoneNumberValid', isPhoneNumberValid),
  timeZone: Yup.string().required('addNewCoach.validations.timeZone'),
  coachType: Yup.string().required('addNewCoach.validations.coachType'),
  description: Yup.string().required('addNewCoach.validations.description'),
});
